import { atom } from "recoil";

const photoThreeState =atom({
    key: 'photoThree',
    default: false
})

export default photoThreeState